import DebtRegistrationReporting from './DebtRegistrationReporting.js';
export default DebtRegistrationReporting;
//# sourceMappingURL=index.js.map